import React, { useEffect } from 'react';

import { Box, Grid, useMediaQuery, useTheme } from '@material-ui/core';

import CustomBreadcrumbs from '../../../components/Bradcrumbs/Breadcrumbs.component';
import StepperSubHeader from '../../../components/Header/StepperSubHeader.component';
import Loader from '../../../components/LoaderSplash/Loader.component';
import { incidentRoad } from '../../../constants/incidents.constant';
import { useAuthDataContext } from '../../../context/auth/auth.provider';
import { useSidebarContext } from '../../../context/sidebar/sidebar.provider';
import SinisterDataProvider, {
  useSinisterDataContext,
} from '../../../context/sinister/sinister.provider';
import { CustomDataLayerPush } from '../../../helpers/CustomDataLayerPush';
import { dataLayerPush } from '../../../helpers/dataLayerPush';
import DataValidation from './Steps/DataValidation.component';
import Fact from './Steps/Fact.component';
import SelectDamage from './Steps/SelectDamage.component';
import SelectDate from './Steps/SelectDate.component';
import SelectPlace from './Steps/SelectPlace/SelectPlace.component';
import WhichVehicle from './Steps/WhichVehicle.component';

const STEPS = [
  {
    title: 'Selección de vehículo',
    content: <WhichVehicle />,
  },
  {
    title: '¿Qué te ocurrió?',
    content: <SelectDamage />,
  },
  {
    title: 'Fecha del hecho',
    content: <SelectDate />,
  },
  {
    title: 'Conductor',
    content: <DataValidation />,
  },
  {
    title: 'Ubicación',
    content: <SelectPlace />,
  },
  {
    title: 'Detalles del hecho',
    content: <Fact />,
  },
];

const SinisterWrapped = () => {
  const { user } = useAuthDataContext();
  const {
    loading,
    step,
    goBack,
    sinister_body,
    resetSinister,
    setStep: setStepFlow,
  } = useSinisterDataContext();
  const {
    setStepperTitle,
    setStep: setStepSidebar,
    stepperTitle,
  } = useSidebarContext();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const newSteps = incidentRoad[sinister_body.incident_type] || [];

  useEffect(() => {
    [...STEPS, ...newSteps][step].title !== 'Revisión' &&
      CustomDataLayerPush({
        event: 'sinister',
        data: {
          user_id: user?.id,
          step_name: [...STEPS, ...newSteps][step === 0 ? step : step - 1]
            .title,
          sinister_type: sinister_body.incident_type,
        },
      });
    setStepperTitle([...STEPS, ...newSteps][step].title);
    setStepSidebar(step);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  useEffect(() => {
    dataLayerPush('inicio_siniestro', user?.id);
    CustomDataLayerPush({
      event: 'sinister',
      data: {
        user_id: user?.id,
        step_name: [...STEPS, ...newSteps][step].title,
        sinister_type: sinister_body.incident_type,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando información'}></Loader>
      </Box>
      <StepperSubHeader
        goBack={goBack}
        step={step}
        totalSteps={[...STEPS, ...newSteps].length}
        closeAction={resetSinister}
      ></StepperSubHeader>
      <Grid
        container
        justify={step === 4 ? 'flex-end' : 'center'}
        style={{ height: 'calc(100% - 4px)' }}
      >
        <Grid
          item
          xs={step === 4 ? 12 : 11}
          md={step === 4 ? 12 : 9}
          lg={step === 4 ? 12 : step === 2 ? 11 : 8}
          xl={step === 4 ? 12 : step === 2 ? 11 : 7}
        >
          <Grid
            container
            style={{
              height: '100%',
              paddingBottom: matches ? 'calc(94px + 24px)' : '',
            }}
          >
            <CustomBreadcrumbs
              isWorkflow
              setStepFlow={setStepFlow}
              setStepSidebar={setStepSidebar}
              step={step}
              stepperTitle={stepperTitle}
              crumbs={[]}
              setStepperTitle={setStepperTitle}
            ></CustomBreadcrumbs>
            <Grid item xs={12}>
              {[...STEPS, ...newSteps][step].content ||
                [...STEPS, ...newSteps][[...STEPS, ...newSteps].length - 1]
                  .content}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

const Sinister = () => {
  return (
    <SinisterDataProvider>
      <SinisterWrapped></SinisterWrapped>
    </SinisterDataProvider>
  );
};

export default Sinister;
